import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=3a224d60&scoped=true"
import script from "./MessageContent.vue?vue&type=script&lang=js"
export * from "./MessageContent.vue?vue&type=script&lang=js"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=3a224d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a224d60",
  null
  
)

export default component.exports